import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { Store } from '../store';

export class BaseService {
	protected static requestCache: {[key: string]: Promise<any>} = {};

	protected store: Store;

	constructor(store: Store) {
		this.store = store;
	}

	protected fetch<T>(url: string, params: {[key: string]: any} = {}, onSuccess: (data: T) => any = (data) => data): Promise<T> {
		params = {
			timeId: this.store.timeId,
			langId: this.store.langId,
			...params
		};

		const requestKey = JSON.stringify({url, params});

		if (!BaseService.requestCache[requestKey]) {
			BaseService.requestCache[requestKey] = axios.get<T>(url, {
				params,
				// qs param serializer format dictionary-like object
				// as `dict[key]=value` in query string
				// is is required by API to parse them correctly
				paramsSerializer: qs.stringify
			})
				.then((res) => res.data)
				.then(onSuccess);
		}

		return BaseService.requestCache[requestKey];
	}

	protected post<T>(url: string, data?: any, config?: AxiosRequestConfig) {
		return axios.post<T>(url, data, config);
	}

	static clearRequestCache() {
		BaseService.requestCache = {};
	}
}
